module.exports = __webpack_public_path__ + "static/media/miami-1.94e96724.jpg";